import { Container } from '@mui/material';

import { styled } from '@/theme/styled';

const LegacyTrainingContainer = styled(Container)(({ theme }) => ({
  flex: 1,
}));

export { LegacyTrainingContainer };
